import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import Collapsible from 'react-collapsible';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';

import AsyncButton from 'components/AsyncButton';
import LoginPage from 'containers/Login';

import messages from './messages';
import Step3 from '../FastCover/Step3';
// import Step4 from '../FastCover/Step4';
import Step5 from '../FastCover/Step5';
import Step6 from '../FastCover/Step6';
import Step7 from '../FastCover/Step7';
import Step8 from '../FastCover/Step8';
import Step9 from '../FastCover/Step9';
import Step10 from '../FastCover/Step10';
import Step11 from '../FastCover/Step11';
import Step12 from '../FastCover/Step12';
import Step15 from '../FastCover/Step15';
import SubmitClaim from '../FastCover/Step14/components/SubmitClaim';
import FieldHeader from '../FastCover/components/FieldHeader/index';
import { setAuthenticationToken } from '../Login/actions';
import { setSelectedPolicyId } from '../App/actions';
import {
  loadClaimFromSummary,
  updateSelectedClaimId,
  loadClaimList,
  downLoadSummary,
  updateSelectedClaimNumber,
  loadClaimType,
} from '../ClaimList/actions';
import saga from '../ClaimList/saga';
import {
  makeSelectClaimList,
  makeSelectClaimTypes,
} from '../ClaimList/selectors';
import reducer from '../ClaimList/reducer';
import injectReducer from '../../utils/injectReducer';
import injectSaga from '../../utils/injectSaga';
import ModalNotice from '../FastCover/Step14/components/ModalNotice';
import { makeSelectStep5 } from '../FastCover/Step5/selectors';
import {
  step10ExpenseLookup,
  step11ExpenseLookup,
  step6ExpenseLookup,
  step7ExpenseLookup,
  step8ExpenseLookup,
  step9ExpenseLookup,
} from '../FastCover/dataMapper/claimCodeMapper';
import { makeDirty, makeError, makeValid } from '../Wizard/actions';
class SummaryScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      exporting: false,
      notice: false,
      claimNo: '',
      sections: [
        {
          id: 3,
          title: messages.section4,
          component: Step5,
        },
        {
          id: 6,
          title: messages.section7,
          component: Step8,
        },
        {
          id: 5,
          title: messages.section6,
          component: Step7,
        },
        {
          id: 4,
          title: messages.section5,
          component: Step6,
        },
        {
          id: 7,
          title: messages.section8,
          component: Step9,
        },
        {
          id: 8,
          title: messages.section9,
          component: Step10,
        },
        {
          id: 9,
          title: messages.section10,
          component: Step11,
        },
        {
          id: 10,
          title: messages.section11,
          component: Step12,
        },
        {
          id: 2,
          title: messages.section2,
          component: Step3,
        },
        {
          id: 15,
          title: messages.section15,
          component: Step15,
        },
        {
          id: 11,
          title: messages.readyToSubmit,
          component: SubmitClaim,
        },
      ],
    };
  }

  componentDidMount() {
    const { params } = this.props.match || {};
    this.props.onRequestClaimJson(params);
    this.props.loadClaimList();
    // this.props.loadClaimType();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.claim &&
      nextProps.claim.claims &&
      nextProps.claim.claims.length
    ) {
      const { params } = this.props.match || {};
      const res = _.find(
        nextProps.claim.claims,
        (i) => i.claimParentId.toString() === params.claimNumber
      );
      this.setState({ claimNo: res.claimNumber });
      this.props.updateSelectedClaimNumber(res.claimNumber);
    }
  }

  showModal = () => {
    this.setState({ notice: true });
  };

  closeModal = () => {
    this.setState({ notice: false });
  };

  exportPdf = () => {
    this.setState({ exporting: true });
    this.showModal();
    const cb = () => {
      this.setState({ exporting: false });
      this.closeModal();
    };
    this.props.downLoadSummary(cb);
  };

  renderCollapsibleHeader = (message) => <FormattedMessage {...message} />;

  render() {
    const { notice, exporting, claimNo, sections } = this.state;
    const { params } = this.props.match || {};
    const { selectedBenefits } = this.props.form;
    const { claim } = this.props;
    const selected =
      !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
        ? selectedBenefits.toJS()
        : selectedBenefits || [];
    return (
      <div className="summary_tbl_wrapper">
        <table
          style={{ marginTop: 20, marginBottom: 20 }}
          className="report-container"
        >
          <thead className="report-header">
            <tr>
              <div
                className="header-info"
                style={{ textAlign: 'right', height: '70px' }}
              >
                <img id="headerLogo" className="logo" width={'175px'} alt="Header Logo" />
              </div>
            </tr>
          </thead>
          <tbody className="report-content">
            <tr>
              <td className="report-content-cell">
                <div style={{ overflow: 'hidden' }}>
                  <FieldHeader>
                    <FormattedMessage {...messages.sectionTitle} />
                  </FieldHeader>
                  {sections.map((section, index) => {
                    if (selected.length) {
                      if (
                        section.id === 4 &&
                        !_.intersection(
                          step6ExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 5 &&
                        !_.intersection(
                          step7ExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 6 &&
                        !_.intersection(
                          step8ExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 7 &&
                        !_.intersection(
                          step9ExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 8 &&
                        !_.intersection(
                          step10ExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 9 &&
                        !_.intersection(
                          step11ExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                    }
                    const Component = section.component;
                    return (
                      <div
                        key={index}
                        className={
                          index === sections.length - 1
                            ? 'pheader showOnPrint'
                            : 'pheader'
                        }
                      >
                        {index === 0 && (
                          <div
                            className="text-center font-weight-bold mb-3 showOnPrint"
                            style={{ fontSize: 24 }}
                          >
                            <span>{claim.cellcaptive} Travel Claim Summary - </span>
                            <span>{claimNo}</span>
                          </div>
                        )}
                        <Collapsible
                          trigger={this.renderCollapsibleHeader(section.title)}
                          key={section.id}
                          open={index === 0}
                        >
                          <div>
                            <Component
                              summaryClaimNo={claimNo}
                              policyNumber={params.policyNumber}
                              token={this.props.match.params.token}
                              isSummary
                              signature
                              submitted
                              handleChange={() => {}}
                              {...this.props}
                              claimTypes={this.props.claimTypes}
                            />
                          </div>
                        </Collapsible>
                      </div>
                    );
                  })}

                  <div className="row justify-content-center mt-3">
                    <div className="col-auto">
                      <AsyncButton
                        id="export-attach-btn"
                        className="btn-authentication"
                        loading={exporting}
                        spinner={exporting}
                        onClick={this.exportPdf}
                      >
                        Download summary
                      </AsyncButton>
                    </div>
                  </div>
                </div>
                <ModalNotice isOpen={notice} onClose={this.closeModal} />
                <div className="d-none">
                  <LoginPage />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

SummaryScreen.propTypes = {
  onRequestClaimJson: PropTypes.func,
  loadClaimList: PropTypes.func,
  match: PropTypes.object,
  claim: PropTypes.object,
  downLoadSummary: PropTypes.func,
  updateSelectedClaimNumber: PropTypes.func,
  form: PropTypes.any,
  claimTypes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  claim: makeSelectClaimList(),
  form: makeSelectStep5(),
  claimTypes: makeSelectClaimTypes(),
});

function mapDispatchToProps(dispatch) {
  return {
    onRequestClaimJson: (params) => {
      dispatch(setAuthenticationToken(params.token));
      dispatch(setSelectedPolicyId(params.policyNumber));
      dispatch(updateSelectedClaimId(params.claimNumber));
      dispatch(loadClaimType());
      dispatch(loadClaimList());
      dispatch(loadClaimFromSummary());
    },
    loadClaimList: () => dispatch(loadClaimList()),
    loadClaimType: () => dispatch(loadClaimType()),
    downLoadSummary: (cb) => dispatch(downLoadSummary(cb)),
    updateSelectedClaimNumber: (claimNumber) =>
      dispatch(updateSelectedClaimNumber(claimNumber)),
    makeError: (s) => dispatch(makeError(s)),
    makeDirty: (s) => dispatch(makeDirty(s)),
    makeValid: (s) => dispatch(makeValid(s)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'claims', reducer });
const withSaga = injectSaga({ key: 'claims', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect
)(SummaryScreen);



// WEBPACK FOOTER //
// ./app/containers/SummaryScreen/index.js